import { anim, stagger } from '../../../motion'
import { Check, Shape } from '../../../primitives'
import { Line, Words } from '../../../v2/kit'
import { useCopy } from '../../i18n'

const SHAPES = [
  ['sq', 'yellow'],
  ['dot', 'green'],
  ['tri', 'pink'],
  ['sq', '#FFFFFF']
]

// Statement-Windows: jeder Satz bekommt die ganze Bühne, danach stehen alle als Liste
const START = 0.22
const SPAN = 0.14
const spot = (i) => [START + i * SPAN, START + (i + 1) * SPAN]

export default function CandFair() {
  const c = useCopy('fair')

  return (
    <div className='cin-full'>
      <div
        className='ch-fair-intro'
        style={anim({ at: [-1, 0], out: [0.16, 0.22], oy: -60 })}
      >
        <h2 className='cin-display cin-display--white ch-fair-title'>
          <Words text={c.title} at={[0, 0.1]} dim={0.3} />
        </h2>
        <Line at={[0.08, 0.14]} y={20} className='ch-fair-text'>
          {c.text}
        </Line>
      </div>

      {c.points.map((p, i) => {
        const [a, b] = spot(i)
        return (
          <div
            key={p}
            className='ch-statement'
            style={anim({
              at: [a, a + 0.03],
              out: [b - 0.02, b],
              y: 80,
              oy: -80,
              s: 0.94
            })}
          >
            <Shape
              kind={SHAPES[i][0]}
              color={SHAPES[i][1]}
              size={44}
              rotate={i * 12}
            />
            <div className='ch-statement__text'>
              <Words text={p} at={[a + 0.01, a + 0.08]} dim={0.3} />
            </div>
          </div>
        )
      })}

      <div className='ch-fair-final'>
        <div style={anim({ at: [0.8, 0.86], y: 40 })}>
          <h2 className='cin-title'>{c.title}</h2>
          <p className='ch-fair-text ch-fair-text--left'>{c.text}</p>
        </div>
        <ul className='ch-fair-list'>
          {c.points.map((p, i) => (
            <li
              key={p}
              style={anim({ at: stagger(0.82, 0.025, 0.06, i), x: 60, y: 0 })}
            >
              <Check size={26} color='#fff' />
              {p}
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}
